export default function setDocumentTitle(title) {
  document.title = title;
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
      var i = document.createElement('iframe');
      i.src = '/favicon.ico';
      i.style.display = 'none';
      i.onload = function() {
        setTimeout(function(){
          i.remove();
        }, 9)
      }
      document.body.appendChild(i);
    }
}


// WEBPACK FOOTER //
// ./src/utils/setDocomentTitle.js